import React from 'react'
import Select from 'react-select'

class SelectMultiple extends React.Component {
  constructor () {
    super()
    this.handleUpdateValue = this.handleUpdateValue.bind(this)
  }

  handleUpdateValue (newValue) {
    this.props.onChange(newValue)
  }

  render () {
    const { field, disabled, id } = this.props
    const hasErrors = field.errors.length > 0 && field.value === ''

    return (
      <div className={hasErrors ? 'has-danger' : ''}>
        <Select
          style={{ color: (hasErrors ? 'red' : ''), backgroundColor: (hasErrors ? 'rgba(255, 55, 55, 0.05)' : '') }}
          instanceId={id || field.name}
          placeholder={this.props.placeHolder}
          autosize={false}
          multi
          autofocus
          options={this.props.options}
          simpleValue
          clearable={this.props.clearable}
          name={field.name}
          disabled={disabled}
          value={field.value}
          onChange={this.handleUpdateValue}
          searchable={this.props.searchable}
        />
        {field.errors.map((error, i) =>
          <div key={i} className='form-control-feedback' style={{ paddingLeft: '10px' }}>{error}</div>
        )}
      </div>
    )
  }
}

export default SelectMultiple



// WEBPACK FOOTER //
// ./src/forms/SelectMultiple.js